var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "no-underline inline-flex",
      attrs: { href: "https://blackpoint.pl/", title: _vm.$t("Home Page") }
    },
    [
      _c("img", {
        staticClass: "logo",
        staticStyle: { transition: "width 0.2s ease-out" },
        attrs: {
          width: _vm.width,
          height: _vm.height,
          src: "/assets/blackpoint-logo.svg",
          alt: _vm.$t(_vm.defaultTitle)
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }